import { createTableColumn, TableCellLayout, TableColumnDefinition } from '@fluentui/react-components'
import { Building24Regular } from '@fluentui/react-icons'
import { RestSchemas } from '@/contexts/QueryProvider'
import { AssetsCellContent } from './AssetsCellContent'
import { RowActionsMenu } from './RowActionsMenu'
import { TemplatesCellContent } from './TemplatesCellContent'

type MessagesWorkspacesEntity = RestSchemas['Messages.Workspaces.Entity']

export const workspaceEntitiesTableColumns: TableColumnDefinition<MessagesWorkspacesEntity>[] = [
  createTableColumn<MessagesWorkspacesEntity>({
    columnId: 'name',
    // compare: (a, b) => {
    //   return a.givenName.localeCompare(b.givenName);
    // },
    renderHeaderCell: () => {
      return 'Name'
    },
    renderCell: (item: MessagesWorkspacesEntity) => {
      return (
        <TableCellLayout media={<Building24Regular color={'#D04A02'} />}>
          <div className="flex flex-col gap-1.5 px-2 py-0">
            <span className="text-base">{item.name}</span>
            <span className="text-gray-medium text-sm">{item.guid}</span>
          </div>
        </TableCellLayout>
      )
    },
  }),
  createTableColumn<MessagesWorkspacesEntity>({
    columnId: 'entityTypeName',
    compare: (a, b) => {
      return a.entityTypeName.localeCompare(b.entityTypeName)
    },
    renderHeaderCell: () => {
      return 'Entity type'
    },
    renderCell: (item: MessagesWorkspacesEntity) => {
      return (
        <TableCellLayout>
          <div className="flex flex-row flex-wrap gap-1.5 px-2 py-0">
            <span className="text-base">{item.entityTypeName}</span>
            <span className="text-gray-medium text-sm">{item.entityTypeDescription}</span>
          </div>
        </TableCellLayout>
      )
    },
  }),
  createTableColumn<MessagesWorkspacesEntity>({
    columnId: 'templateFileCount',
    compare: (a, b) => {
      return (a.templateFileCount ?? 0) - (b.templateFileCount ?? 0)
    },
    renderHeaderCell: () => {
      return 'Templates'
    },
    renderCell: (item: MessagesWorkspacesEntity) => {
      return <TemplatesCellContent entity={item} />
    },
  }),
  createTableColumn<MessagesWorkspacesEntity>({
    columnId: 'dataAssetFileCount',
    compare: (a, b) => {
      return (a.dataAssetFileCount ?? 0) - (b.dataAssetFileCount ?? 0)
    },
    renderHeaderCell: () => {
      return 'Assets'
    },
    renderCell: (item: MessagesWorkspacesEntity) => <AssetsCellContent entity={item} />,
  }),
  createTableColumn<MessagesWorkspacesEntity>({
    columnId: 'actions',
    renderHeaderCell: () => {
      return 'Actions'
    },
    renderCell: (item) => <RowActionsMenu entity={item} />,
  }),
]
